module.exports = __webpack_public_path__ + "static/media/png.c0a26a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/png.png
// module id = 2565
// module chunks = 0